import React, { Component } from 'react'
import { Link } from 'react-router'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import isEqual from 'lodash.isequal'

import classNames from './PlaylistEditor.css'
import { fetchPlaylists, saveList } from '../redux/playlists'
import { fetchAlbums } from '../redux/albums'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import Checklist from '../components/Checklist'
import SortableList from '../components/playlist/SortableList'
import SortableBar from '../components/playlist/SortableBar'
import AlbumPicker from '../components/playlist/AlbumPicker'
import { getItemName } from '../components/playlist/utils'
import { userHasPerm } from '../utils/auth'
import { createImageGetter } from '../utils/images'

class ListEditor extends Component {
  state = {
    name: this.props.list ? this.props.list.name : '',
    structure: this.props.list ? JSON.parse(this.props.list.json_data) : { albums: [] }
  }
  componentDidMount () {
    const { params, location, albums, fetchAlbums, removeLocationQuery } = this.props
    if (!albums) fetchAlbums()

    if (params.id) {
      const { list, fetchPlaylists } = this.props
      if (!list) {
        fetchPlaylists()
      }
    }

    if (location.query.addAlbum) {
      this.addAlbum({ album: location.query.addAlbum })
      removeLocationQuery(params.id)
    }
  }
  componentWillReceiveProps (nextProps) {
    if (!this.props.list && nextProps.list) {
      this.setState({
        name: nextProps.list.name,
        structure: JSON.parse(nextProps.list.json_data)
      })
    }
  }
  onReorder = (albums) => {
    this.setState({
      structure: {
        ...this.state.structure,
        albums
      }
    })
  }
  updateName = e => {
    this.setState({
      name: e.target.value
    })
  }
  addAlbum = (album = {}) => {
    const { structure } = this.state
    this.updateStructure('albums', structure.albums.concat(album))
    this.setState({
      editIndex: structure.albums.length
    })
  }
  removeAlbum = index => {
    const { albums } = this.state.structure
    this.updateStructure('albums', [
      ...albums.slice(0, index),
      ...albums.slice(index + 1)
    ])
  }
  updateStructure = (key, value) => {
    const { structure } = this.state
    this.setState({
      structure: {
        ...structure,
        [key]: value
      }
    })
  }
  onSave = () => {
    const { params, saveList } = this.props
    const { name, structure } = this.state
    saveList({ name }, structure, params.id, '/groups')
  }
  isFormValid = () => {
    const { params, list, submitting } = this.props
    const { name, structure } = this.state
    if (submitting) {
      return false
    }
    if (params.id) {
      return (name && name !== list.name) || isEqual(structure, JSON.parse(list.json_data)) === false
    }
    return name
  }
  getCover = item => {
    const album = this.props.entities.albums[item.album]
    if (!album) {
      return null
    }
    return this.props.getImageSource(album.cover)
  }
  renderAlbum = (album, index) => {
    return (
      <SortableBar
        key={index}
        title={getItemName(album, this.props.entities)}
        onRemove={() => this.removeAlbum(index)}
        thumb={this.getCover(album)}
      />
    )
  }
  renderHeading (heading) {
    return (
      <div className={classNames.heading}>
        {heading}
      </div>
    )
  }
  render () {
    const { params, list, albums, isOwner, error, fetchPlaylists } = this.props
    if (!albums) {
      return <LoadingSpinner />
    }
    if (params.id) {
      if (!list) {
        return <LoadingSpinner />
      }
      if (error) {
        return <ErrorMessage message='Group could not be loaded' onRetry={fetchPlaylists} />
      }
    }
    const { submitting, canEditPlaylists } = this.props
    const { name, structure } = this.state
    return (
      <div className={classNames.page}>
        {this.renderHeading('Group name')}
        <input
          type='text'
          value={name}
          onChange={this.updateName}
          autoFocus={!params.id}
        />
        {this.renderHeading('Albums')}
        <SortableList
          items={structure.albums}
          renderItem={this.renderAlbum}
          sortHandle='handle'
          onSort={this.onReorder}
          itemClass={classNames.album}
        />
        <AlbumPicker
          albums={albums}
          exclude={structure.albums.map(item => item.album)}
          isOwner={isOwner}
          onChange={id => this.addAlbum({ album: id })}
          resetOnChange
          collapseOnSelect
          getImageSource={this.props.getImageSource}
          placeholder='Add album to group'
        />
        {canEditPlaylists && this.renderHeading('Options')}
        {canEditPlaylists &&
          <Checklist
            items={[{
              value: true,
              title: 'Playlist Albums Only',
              subtitle: 'Album group will not appear on home page'
            }]}
            value={structure.playlistsOnly ? [true] : []}
            onChange={array => this.updateStructure('playlistsOnly', array.length !== 0)}
          />
        }
        <div className={classNames.buttons}>
          <Link to='/groups' className={classNames.cancelButton}>
            Cancel
          </Link>
          <button
            onClick={this.onSave}
            className={classNames.saveButton}
            disabled={!this.isFormValid()}>
            Save Group
          </button>
        </div>
        <LoadingSpinner show={submitting} />
      </div>
    )
  }
}

const mapStateToProps = ({ entities, albums, auth, playlists, search, queues }, { params }) => ({
  entities,
  search,
  list: params.id ? entities.playlists[params.id] : null,
  error: playlists.error,
  albums: albums.all.data && albums.all.data.map(id => entities.albums[id]),
  isOwner: album => album.user_id === auth.user.id,
  submitting: playlists.submitting,
  submitError: playlists.submitError,
  canEditPlaylists: userHasPerm(auth.user, 'create_channels'),
  getImageSource: createImageGetter(auth)
})

const mapDispatchToProps = {
  fetchAlbums,
  fetchPlaylists,
  saveList,
  removeLocationQuery: id => dispatch => dispatch(push(`/groups/${id}`))
}

export default connect(mapStateToProps, mapDispatchToProps)(ListEditor)



// WEBPACK FOOTER //
// ./src/pages/ListEditor.js